import React, { FC } from 'react';
import styled from 'styled-components';

import App from 'models/app';

import Clock, { Placeholder } from './Clock';
import { sortFavoriteClockfaces } from './util';

interface ClocksRowProps {
  favoriteClocksEnabled: boolean;
  favoriteClocks: App[];
  maxFavoriteClocks: number;
  deviceName: string;
  activeClock: App;
  setFocusedClock: (id: string) => any;
}

const ClocksRowContainer = styled.div`
  display: flex;
  justify-content: space-between;

  overflow: hidden;

  padding: 10px 10px 24px;
`;

const createPlaceholders = ({ count, deviceName, size }: any) => {
  const placeholders = [];

  for (let i = 0; i < count; i += 1) {
    placeholders.push((
      <Placeholder
        index={i}
        key={i}
        deviceName={deviceName}
        size={size}
      />
    ));
  }

  return placeholders;
};

const ClocksRow: FC<ClocksRowProps> = ({
  favoriteClocksEnabled,
  favoriteClocks = [],
  deviceName,
  maxFavoriteClocks,
  activeClock,
  setFocusedClock
}) => {
  if (!favoriteClocksEnabled) {
    return (
      <ClocksRowContainer>
        <Clock
          key={activeClock.id}
          deviceName={deviceName}
          clock={activeClock}
          active={true}
          setFocusedClock={setFocusedClock}
          index={0}
        />
      </ClocksRowContainer>
    );
  }

  const sortedClocks = sortFavoriteClockfaces(favoriteClocks, activeClock);

  let imageSize;
  if (favoriteClocks.length !== 0) {
    imageSize = favoriteClocks[0].banners[0];
  } else {
    if (activeClock && activeClock.banners) {
      imageSize = activeClock.banners[0];
    }
  }

  return (
    <ClocksRowContainer>
      {sortedClocks
        .map((app, index) => (
          <Clock
            key={app.id}
            deviceName={deviceName}
            clock={app}
            active={activeClock.id === app.id}
            setFocusedClock={setFocusedClock}
            index={index}
          />
        ))}
      {createPlaceholders({
        count: maxFavoriteClocks - favoriteClocks.length,
        deviceName,
        size: imageSize
      })}
    </ClocksRowContainer>
  )
};

export default ClocksRow;
